// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"ArchivedProductsList_Pagination__2ng1F","ListItem":"ArchivedProductsList_ListItem__13Wnk","ListItemSkeleton":"ArchivedProductsList_ListItemSkeleton__1ok-p"};